var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { avoidAuthToken } from "./../../../constants";
import LoginFlowConfigURL from "@adapters/infrastructures/urlConfig/LoginFlow/LoginFlowConfigURL";
import clientValidateOTPMapper from "@domains/features/LoginFlow/mapper/clientValidateOTPMapper";
import clientGenerateOTPMapper from "@domains/features/LoginFlow/mapper/clientGenOTPMapper";
import guestValidateMapper from "@domains/features/LoginFlow/mapper/guestValidateMapper";
import clientSetPasswordMapper from "@domains/features/LoginFlow/mapper/clientSetPassword";
import ClientForgotUserIDMapper from "@domains/features/LoginFlow/mapper/clientForgotUserID";
import guestLoginSetMpinMapper from "@domains/features/LoginFlow/mapper/guestLoginSetMPIN";
import validateMPINMapper from "@domains/features/LoginFlow/mapper/GuestValidateMPIN";
import getAccountDetailsMapper from "@domains/features/LoginFlow/mapper/getAccountDetailsMapper";
import { LoginClientDataMapper } from "@domains/features/LoginFlow/mapper/ClientLoginMapper";
import checkNAddEmailMapper from "@domains/features/LoginFlow/mapper/iCheckNAddEmail";
import { addAccountMapper } from "@domains/features/LoginFlow/mapper/addAccountMapper";
import GuestForgotPINMapper from "@domains/features/LoginFlow/mapper/guestForgotPIN";
import clientValidateUserIDMapper from "@domains/features/LoginFlow/mapper/clientValidateUserID";
import clientValidatePasswordMapper from "@domains/features/LoginFlow/mapper/clientValidatePasswordMapper";
import unblockUserMapper from "@domains/features/LoginFlow/mapper/unblockUserMapper";
import guestRegEmailVerifyOTPMapper from "@domains/features/LoginFlow/mapper/guestRegEmailVerifyOTPMapper";
var LoginFLowRepository = /** @class */ (function () {
    function LoginFLowRepository(http) {
        this.http = http;
    }
    LoginFLowRepository.prototype.totpValidateOtp = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, body, loginData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL("".concat(LoginFlowConfigURL.loginBaseKambalaUrl).concat(req === null || req === void 0 ? void 0 : req.accCode, "/totplogin"));
                        body = {
                            ip: req === null || req === void 0 ? void 0 : req.ip,
                            pwd: req === null || req === void 0 ? void 0 : req.pwd,
                            accTyp: req === null || req === void 0 ? void 0 : req.accTyp,
                            loginFlow: req === null || req === void 0 ? void 0 : req.loginFlow,
                            totp: req === null || req === void 0 ? void 0 : req.totp,
                        };
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: body,
                            })];
                    case 1:
                        loginData = _a.sent();
                        return [2 /*return*/, LoginClientDataMapper(loginData === null || loginData === void 0 ? void 0 : loginData.data)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.totpGenerateOtp = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, body, totp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginFlowConfigURL.loginBaseKambalaUrl + "verifyuidpwd/" + (req === null || req === void 0 ? void 0 : req.userId));
                        body = {
                            accTyp: req === null || req === void 0 ? void 0 : req.accTyp,
                            pwd: req === null || req === void 0 ? void 0 : req.pwd,
                        };
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "Post",
                                url: url.toString(),
                                body: body,
                                avoidAuthToken: true,
                            })];
                    case 1:
                        totp = _a.sent();
                        return [2 /*return*/, totp === null || totp === void 0 ? void 0 : totp.data];
                }
            });
        });
    };
    LoginFLowRepository.prototype.getUnblockUser = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, unblockUser;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL("".concat(LoginFlowConfigURL.loginBaseKambalaloginHelpUrl).concat(LoginFlowConfigURL.unblockUser).concat(req.userId));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        unblockUser = _a.sent();
                        return [2 /*return*/, unblockUserMapper(unblockUser === null || unblockUser === void 0 ? void 0 : unblockUser.data)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.clientSetPassword = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, clientSetPassword;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginFlowConfigURL.loginBaseKambalaloginHelpUrl +
                            LoginFlowConfigURL.setPassword +
                            req.userID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.clientSetPassword,
                            })];
                    case 1:
                        clientSetPassword = _a.sent();
                        return [2 /*return*/, clientSetPasswordMapper(clientSetPassword)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.clientValidateOTP = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, clientValidate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginFlowConfigURL.loginBaseUrl +
                            req.userID +
                            LoginFlowConfigURL.clientValidateOTP);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.validateReq,
                            })];
                    case 1:
                        clientValidate = _a.sent();
                        return [2 /*return*/, clientValidateOTPMapper(clientValidate)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.clientGenerateOTP = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, clientGenerateOTP;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginFlowConfigURL.loginBaseKambalaloginHelpUrl +
                            LoginFlowConfigURL.generateOTP +
                            req.userID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.clientReq,
                            })];
                    case 1:
                        clientGenerateOTP = _a.sent();
                        return [2 /*return*/, clientGenerateOTPMapper(clientGenerateOTP)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.clientForgotUserID = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, clientForgotUserID;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginFlowConfigURL.loginBaseKambalaloginHelpUrl +
                            LoginFlowConfigURL.clientForgetUserID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        clientForgotUserID = _a.sent();
                        return [2 /*return*/, ClientForgotUserIDMapper(clientForgotUserID)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.getImage = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, clientValidateUserID;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL("".concat(LoginFlowConfigURL.loginBaseKambalaUrl).concat(LoginFlowConfigURL.clientLoginValidateUser).concat(req.userId));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1:
                        clientValidateUserID = _a.sent();
                        return [2 /*return*/, clientValidateUserIDMapper(clientValidateUserID === null || clientValidateUserID === void 0 ? void 0 : clientValidateUserID.data)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.getQuestionsForLogin = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, request, questionData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL("".concat(LoginFlowConfigURL.loginBaseKambalaUrl).concat(LoginFlowConfigURL.clientLoginValidatePassword).concat(req.userId));
                        request = {
                            accTyp: req.accType,
                            ip: "",
                            pwd: req.pwd,
                        };
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: request,
                            })];
                    case 1:
                        questionData = _a.sent();
                        return [2 /*return*/, clientValidatePasswordMapper(questionData === null || questionData === void 0 ? void 0 : questionData.data)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.guestLoginSetMpin = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, guestLoginSetMpin;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.guestSetMPIN);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: false,
                            })];
                    case 1:
                        guestLoginSetMpin = _a.sent();
                        return [2 /*return*/, guestLoginSetMpinMapper(guestLoginSetMpin)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.guestForgotSetMpin = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, guestForgotSetMpin;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginFlowConfigURL.guestRealBaseAPI +
                            LoginFlowConfigURL.guestForgotSetMPIN);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: req,
                                avoidAppID: false,
                            })];
                    case 1:
                        guestForgotSetMpin = _a.sent();
                        return [2 /*return*/, guestLoginSetMpinMapper(guestForgotSetMpin)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.guestLoginValidateMPIN = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, validateMPIN;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.validateMPIN);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: false,
                            })];
                    case 1:
                        validateMPIN = _a.sent();
                        return [2 /*return*/, validateMPINMapper(validateMPIN === null || validateMPIN === void 0 ? void 0 : validateMPIN.data)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.getAccountDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, getAccountDetails;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.accountCheck);
                        url.searchParams.append("cryCd", req.crycd);
                        url.searchParams.append("mob", req.mob);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        getAccountDetails = _a.sent();
                        return [2 /*return*/, getAccountDetailsMapper(getAccountDetails === null || getAccountDetails === void 0 ? void 0 : getAccountDetails.data)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.getLoginDataForOtp = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, loginData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL("".concat(LoginFlowConfigURL.loginBaseKambalaUrl).concat(LoginFlowConfigURL.clientLoginvalidateOTP).concat(req.userId));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        loginData = _a.sent();
                        return [2 /*return*/, LoginClientDataMapper(loginData === null || loginData === void 0 ? void 0 : loginData.data)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.checkNAddEmail = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, checknaddEmail;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.checknaddEmail);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: false,
                            })];
                    case 1:
                        checknaddEmail = _a.sent();
                        return [2 /*return*/, checkNAddEmailMapper(checknaddEmail === null || checknaddEmail === void 0 ? void 0 : checknaddEmail.data)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.guestRegisterAddAccount = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, addAccount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.addAccount);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: false,
                            })];
                    case 1:
                        addAccount = _a.sent();
                        return [2 /*return*/, addAccountMapper(addAccount === null || addAccount === void 0 ? void 0 : addAccount.data)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.guestForgotPIN = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, guestForgotPIN;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.forgotPIN);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        guestForgotPIN = _a.sent();
                        return [2 /*return*/, GuestForgotPINMapper(guestForgotPIN === null || guestForgotPIN === void 0 ? void 0 : guestForgotPIN.data)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.guestRegValidateOTP = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, guestValidate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.guestValidate);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: false,
                            })];
                    case 1:
                        guestValidate = _a.sent();
                        return [2 /*return*/, guestValidateMapper(guestValidate === null || guestValidate === void 0 ? void 0 : guestValidate.data)];
                }
            });
        });
    };
    LoginFLowRepository.prototype.guestRegEmailVerifyOTP = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, EmailVerifyOTP;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.guestverifyEmail);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: false,
                            })];
                    case 1:
                        EmailVerifyOTP = _a.sent();
                        return [2 /*return*/, guestRegEmailVerifyOTPMapper(EmailVerifyOTP === null || EmailVerifyOTP === void 0 ? void 0 : EmailVerifyOTP.data)];
                }
            });
        });
    };
    return LoginFLowRepository;
}());
export default LoginFLowRepository;
